export const TOKEN = process.env.REACT_APP_MAP_BOX_TOKEN;
